import React from 'react'
import PropTypes from 'prop-types'

import { PAYMENT_STATUSES } from 'models/Payment'

// Components
import Select from 'ui/Form/Select'

export const SelectPaymentStatus = ({ value, onChange, ...props }) => {
  return (
    <Select
      value={value}
      multiple={false}
      placeholder="Status"
      options={PAYMENT_STATUSES}
      onChange={onChange}
      {...props}
    />
  )
}

SelectPaymentStatus.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
}

SelectPaymentStatus.defaultProps = {
  value: '',
  onChange: () => {},
}

export default SelectPaymentStatus
